import debounce from "@lodash/debounce"
import throttle from "@lodash/throttle"

document.addEventListener("DOMContentLoaded", () => {
  const menuDelay = {
    open: 350,
    close: 500,
  }
  let forceHide = false

  const $header = document.querySelector("nova-header")
  const $openMenu = document.querySelector(".js-menu-toggle")
  const $closeMenu = document.querySelector(".js-menu-close-button")
  const $drawerButtons = $header.querySelectorAll(".js-header-drawer-button")
  const $headerDrawer = $header.querySelectorAll(".js-header-drawer")
  const $accordions = document.querySelectorAll("component-accordion")

  $openMenu.addEventListener("click", () => {
    document.dispatchEvent(new CustomEvent("nova:mobile-menu:open"))
  })

  $closeMenu.addEventListener("click", () => {
    document.dispatchEvent(new CustomEvent("nova:mobile-menu:close"))
  })

  document.addEventListener("nova:menu:closed-in-modal", () => {})

  const handleInlineMenuDrawer = (event) => {
    forceHide = false
    const $button = event.target.closest(".js-header-drawer-button")
    if (!$button) return

    const targetReference = $button.dataset.target
    const $target = $header.querySelector(`#${targetReference}`)
    if (!$target) return

    for (const $drawer of $headerDrawer) {
      if ($drawer === $target) {
        if (!$drawer.hasAttribute("is-open")) {
          setTimeout(() => {
            if (!forceHide) $drawer.show()
          }, menuDelay.open)
        } else if (event.type === "click") {
          forceHide = true
          setTimeout(() => {
            $drawer.hide()
          }, menuDelay.close)
        }
      } else {
        $drawer.hide()
      }
    }
  }

  const handleDrawerAttributesAndEvents = (event) => {
    const $drawer = event.target.closest(".js-header-drawer")
    if (!$drawer) return
    const targetReference = $drawer.id
    const $button = $header.querySelector(`[data-target="${targetReference}"]`)
    if (!$button) return
    if (event.type === "sl-hide") {
      $drawer.removeAttribute("is-open")
      $button.removeAttribute("is-open")
      dispatchDrawerHideEvent($drawer)
    } else if (event.type === "sl-show") {
      $drawer.setAttribute("is-open", "")
      $button.setAttribute("is-open", "")
      dispatchDrawerShowEvent($drawer)
    }
  }

  const dispatchDrawerShowEvent = (target) => {
    window.dispatchEvent(
      new CustomEvent("nova:header-drawer:open", {
        bubbles: true,
        detail: { target: target },
      })
    )
  }

  const dispatchDrawerHideEvent = (target) => {
    window.dispatchEvent(
      new CustomEvent("nova:header-drawer:close", {
        bubbles: true,
        detail: { target: target },
      })
    )
  }

  for (const $drawer of $headerDrawer) {
    $drawer.addEventListener("sl-hide", handleDrawerAttributesAndEvents)
    $drawer.addEventListener("sl-show", handleDrawerAttributesAndEvents)
  }

  for (const $button of $drawerButtons) {
    $button.addEventListener("click", handleInlineMenuDrawer)
  }

  const closeAccordions = debounce(
    ($accordion) => {
      if (
        $accordion.animationState != "idle" ||
        $accordion.isFullyOpen === $accordion.isFullyClosed
      ) {
        return
      }
      $accordion.open = false
    },
    332,
    { leading: true, trailing: true }
  )

  const toggleAccordion = (event) => {
    const target = event.target
    const $accordion = target.closest("component-accordion")

    if (
      $accordion.animationState != "idle" ||
      $accordion.isFullyOpen === $accordion.isFullyClosed
    ) {
      return
    }

    switch (event.type) {
      case "pointerenter": {
        if (!$accordion.isOpen) {
          $accordion.setAttribute("data-open-event", event.type)
          $accordion.open = true
        }
        break
      }
      case "pointerleave": {
        // if ($accordion.dataset.openEvent !== "click") {
        //   $accordion.open = false
        // }
        $accordion.open = false
        break
      }
      case "keydown": {
        $accordion.open = false
        break
      }
      case "click": {
        if ($accordion._trigger?.contains(target)) {
          if (!$accordion.open) {
            $accordion.setAttribute("data-open-event", event.type)
          }
          $accordion.open = !$accordion.open
        }
        break
      }
      default:
        if (!$accordion.open) {
          $accordion.setAttribute("data-open-event", event.type)
        }
        $accordion.open = !$accordion.open
        break
    }

    $accordion.closeOthers()
  }
  const debounceOpenAccordion = debounce(toggleAccordion, 332, {
    leading: false,
    trailing: true,
  })
  const throttleOpenAccordion = throttle(toggleAccordion, 332, {
    leading: true,
    trailing: true,
  })

  for (const $accordion of $accordions) {
    $accordion.addEventListener("pointerenter", debounceOpenAccordion)
    $accordion.addEventListener("pointerleave", debounceOpenAccordion)
    $accordion.addEventListener("click", (event) => {
      const target = event.target
      const $accordion = target.closest("component-accordion")
      if (event.type === "click" && !$accordion.isFullyOpen) {
        $accordion.setAttribute("data-open-event", event.type)
      }
      throttleOpenAccordion(event)
    })

    $accordion.addEventListener("keydown", (e) => {
      const escKey = e.key == "Escape" || e.key === "Esc" || e.keyCode === 27
      if (!e.repeat && escKey) {
        throttleOpenAccordion(e)
      }
    })
  }

  document.addEventListener("accordion:closeOthers", ({ target }) => {
    for (const $accordion of $accordions) {
      if ($accordion.id != target.id && $accordion.open) {
        closeAccordions($accordion)
      }
    }
  })

  const addHeaderOffsetVariable = () => {
    document.documentElement.style.setProperty(
      "--header-height",
      `${document.querySelector(".header").offsetHeight}px`
    )
    document.documentElement.style.setProperty(
      "--announcement-bar-height",
      `${document.querySelector(".announcement-bar").offsetHeight}px`
    )
  }

  addHeaderOffsetVariable()
  window.addEventListener("resize", addHeaderOffsetVariable)
})
